import "./Compliance3.module.css";
import Header from "@/reusable_sections/Header";
import Compliance from "./sections/Compliance";
import Complianceresources from "./sections/Complianceresources";
import Footer from "@/reusable_sections/Footer";
export default function Compliance3Page() {
  return <div>
      <Header />
      <Compliance />
      <Complianceresources />
      <Footer />
    </div>;
}